<script type='ts'>
    export let address = {
        Name: '',
        AddressLine1: '',
        AddressLine2: '',
        City: '',
        State: '',
        Zip: ''
    }
    export let type
    export let isError
</script>
<style>
    input.readonly {
        cursor: not-allowed;
    }

    input.isError {
        border-color: var(--red);
    }

    label.isError {
        color: var(--red);
    }

    @media (max-width: 25rem) {
        .tripleGroup {
            flex-direction: column;
        }

        .doubleGroup {
            margin: 0;
        }
    }
</style>
<form class="flex flex-column">

    <label for="{type}name" class:isError>Name</label>

    <input name="name"
           required id="{type}name"
           placeholder="Name"
           autocomplete="section-{type} shipping name"
           bind:value={address.Name} class:isError>
    <label for="{type}StreetAddress" class:isError>Street Address (With Unit number)</label>
    <input name="{type}street"
           required id="{type}StreetAddress"
           placeholder="100 Example St, Unit 101"
           autocomplete="section-{type} shipping street-address" bind:value={address.AddressLine1} class:isError>

    <div class="doubleGroup flex flex-auto">
        <div class="flex flex-column flex-auto ">
            <label for="{type}Zip" class:isError>Zip</label>
            <input name="{type}zip"
                   required id="{type}Zip"
                   placeholder="Zip"
                   autocomplete="section-{type} shipping postal-code"
                   maxlength={11}
                   bind:value={address.Zip} class:isError>
        </div>
        <div class="flex flex-column ml1">
            <label for="{type}Country" class:isError>Country</label>
            <input class='readonly'
                   name="{type}country"
                   required
                   id="{type}Country"
                   value="USA"
                   size={3}
                   readonly
                   autocomplete="section-{type} shipping country" class:isError>
        </div>
    </div>
    <!--    <div class='tripleGroup flex flex-auto'>-->
    <!--        <div class="flex flex-column flex-auto">-->
    <!--            <label for="{type}frmAddressS2" class:isError>Address Line 2</label>-->
    <!--            <input name="address-line2" required id="{type}frmAddressS2" placeholder="Address Line 2"-->
    <!--                   autocomplete="{type} address-line2" bind:value={address.AddressLine2} class:isError>-->
    <!--            <label for="{type}frmCityS" class:isError>City</label>-->
    <!--            <input name="ship-city" required id="{type}frmCityS" placeholder="City" autocomplete="{type} address-level2"-->
    <!--                   bind:value={address.City} class:isError>-->
    <!--        </div>-->
    <!--    </div>-->
</form>